import config from '@/config'
import { resolve } from '@sentry/utils'
import axios from 'axios'
import reject from 'lodash/reject'
import { cartApi } from '@/api/carts.js'
import { thailandpostmartApi } from '@/api/thailandpostmart'

export default {
  setLang: function ({ commit }, payload) {
    commit('SET_LANG', payload)
  },
  addToCart: function (
    { state, commit, getters, dispatch },
    { product, userId }
  ) {
    return new Promise(async (resolve, reject) => {
      // if (state.cart.length > 0) {
      // console.log('cart: ', state.cart)
      var index = state.cart.findIndex(function (val) {
        if (getters.isThailandPostMart) {
          return val.id == product.id
        }
        return val.id == product.id && val.option == product.option
      })

      if (index != -1) {
        try {
          if (state.cart[index].quantity == product.max) {
            // สินค้าเท่ากับของใน stock แล้วบวกเพิ่มไม่ได้อีก
          } else if (
            state.cart[index].quantity + product.quantity >=
            product.max
          ) {
            // สินค้าในตะกร้าและเพิ่มใหม่ มีมากกว่า stock
            if (getters.isThailandPostMart) {
              try {
                await dispatch('addThailandPostMartCart', {
                  product: {
                    ...state.cart[index],
                    quantity: product.max - state.cart[index].quantity
                  },
                  userId
                })
              } catch (error) {
                reject(error)
              }
            }
            commit('EDIT_QUANTITY', { index: index, quantity: product.max })
            if (
              getters.getPageProfile.type == 'reka' &&
              product.addon_json &&
              product.addon_json.embroideredNameList
            ) {
              let embroideredNameList = [
                ...(state.cart[index].addon_json.embroideredNameList || []),
                ...product.addon_json.embroideredNameList
              ]
              commit('EDIT_ADDON_JSON', {
                index: index,
                name: 'embroideredNameList',
                embroideredNameList
              })
            }
          } else if (
            state.cart[index].quantity + product.quantity <
            product.max
          ) {
            // สินค้าในตะกร้าและเพิ่มใหม่ มีน้อยกว่า stock
            if (getters.isThailandPostMart) {
              try {
                await dispatch('addThailandPostMartCart', {
                  product: {
                    ...state.cart[index],
                    quantity: product.quantity
                  },
                  userId
                })
              } catch (error) {
                reject(error)
              }
            }
            commit('EDIT_QUANTITY', {
              index: index,
              quantity: state.cart[index].quantity + product.quantity
            })
            if (
              getters.getPageProfile.type == 'reka' &&
              product.addon_json &&
              product.addon_json.embroideredNameList
            ) {
              let embroideredNameList = [
                ...(state.cart[index].addon_json.embroideredNameList || []),
                ...product.addon_json.embroideredNameList
              ]
              commit('EDIT_ADDON_JSON', {
                index: index,
                name: 'embroideredNameList',
                embroideredNameList
              })
            }
          }
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error)
        }
      } else {
        // ยังไม่เคยเพิ่มในตะกร้า
        if (getters.isThailandPostMart) {
          try {
            await dispatch('addThailandPostMartCart', { product, userId })
            commit('ADD_CART', product)
          } catch (error) {
            reject(error)
          }
        } else {
          commit('ADD_CART', product)
        }
      }
      resolve()
    })
  },
  updateAllCart({ commit }, cart) {
    commit('SET_ALL_CART', cart)
  },
  thailandpostmartDeleteFromCart: async function (
    { state, getters, dispatch },
    { index, userId }
  ) {
    if (index != -1) {
      if (getters.isThailandPostMart) {
        await dispatch('removeThailandPostMartCart', {
          product: state.cart[index],
          userId
        })
      }
      state.cart.splice(index, 1)
      if ((state.cart && state.cart.length == 0) || !state.cart) {
        return true
      }
    }
    return false
  },
  deleteFromCart: function ({ state }, rand_id) {
    const index = state.cart.findIndex((product) => product.rand_id == rand_id)
    if (index != -1) {
      if (state.cart[index] && state.cart[index].cart_id) {
        const cartId = state.cart[index].cart_id
        try {
          cartApi.deleteCartById(cartId)
        } catch (error) {}
      }
      state.cart.splice(index, 1)
      if ((state.cart && state.cart.length == 0) || !state.cart) {
        return true
      }
    }
    return false
  },
  deleteAllItemsInCart: function ({ state }) {
    state.cart = []
  },
  setCart: function ({ state }, products) {
    state.cart = products
  },
  getWholeSaleStatus: function ({ commit }, pageid) {
    return new Promise((resolve, reject) => {
      var url =
        config.getConfig('serverUrl') + 'wholesale_status?pageid=' + pageid
      axios.get(url).then((response) => {
        response = response.data
        if (response.responsecode == 200) {
          commit(
            'SET_WHOLESALE_STATUS',
            response.data.wholesale_status === true
          )
          resolve()
        } else {
          reject()
        }
      })
    })
  },
  getWholeSale: function ({ commit }, pageid) {
    return new Promise((resolve, reject) => {
      var url = config.getConfig('serverUrl') + 'wholesale?pageid=' + pageid
      axios.get(url).then((response) => {
        response = response.data
        if (response.responsecode == 200) {
          commit('SET_WHOLESALE', response.wholesalelist)
          resolve()
        } else {
          reject()
        }
      })
    })
  },
  updateCartStock: function ({ state, commit }, product) {
    var cartIndex = state.cart.findIndex(function (cart) {
      return (
        cart.id == product.id &&
        cart.optionDetail &&
        cart.optionDetail[0] == product.stockid
      )
    })

    if (cartIndex || cartIndex === 0) {
      commit('SET_PRODUCT_IN_CART', {
        index: cartIndex,
        quantity: product.quantity
      })
    }
  },
  updatePageProfile: function (state, user) {
    var url = config.getConfig('serverUrl') + 'usershoplang'

    var data = {
      userid: user.userid,
      usershoplang: user.lang,
      pageid: user.pageid
    }

    axios.put(url, data).then(() => {})
  },
  updateShopColor: function ({ commit }, color) {
    commit('SET_THEME_COLOR', color)
  },
  loadPageProfile: function ({ state, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      state.loadingPageProfile = true
      dispatch('getPageProfile', payload).then(
        (response) => {
          state.pageProfile = response
          state.loadingPageProfile = false
          resolve()
        },
        (error) => {
          // console.error(error)
          state.loadingPageProfile = false
          reject(error)
        }
      )
    })
  },
  getPageProfile: async function (state, payload) {
    let url = ''
    if ([...config.thaiairways.pageid].includes(payload.pagename)) {
      url = `${config.thaiairways.serverUrl}pageprofile`
    } else {
      url = `${config.getConfig('serverUrl')}pageprofile`
    }
    var response = await axios.get(url, {
      params: {
        ...payload,
        pageid: payload.pagename,
        userid: payload.userid
      }
    })
    response = response.data
    if (response.responsecode == 200) {
      if (response.pageprofile) {
        return response.pageprofile
      }
    } else {
      // console.log(response);
    }
  },
  getUserShopLang: async function (state, data) {
    axios.defaults.headers.common = {
      AUTHORIZATION: 'BEARER ' + data.userid + ' shop'
    }
    var url =
      config.getConfig('serverUrl') +
      'usershoplang?userid=' +
      data.userid +
      '&pageid=' +
      data.pageid
    var response = await axios.get(url)
    if (response.data && response.data.responsecode == 200) {
      return response.data.data
    } else {
      return null
    }
  },
  getSalePage({ commit }, pageid) {
    let url = config.getConfig('serverUrl') + 'sale_page' + '/' + pageid
    axios.defaults.headers.common = {
      'api-key': '1-2-3-sharks-landed'
    }
    axios
      .get(url)
      .then((response) => {
        if (response.data.success) {
          commit('GET_SALEPAGE', response.data.result)
        }
      })
      .catch((e) => {
        // eslint-disable-next-line no-console
        console.error(e)
      })
  },
  async getThailandPostMartCategory() {
    let url = config.thailandpostmart.productUrl + 'api_category'
    let auth = config.thailandpostmart.auth
    axios.get(url, { headers: auth }).then((res) => {
      if (res.data.res_code == 200) {
        resolve(res.data.res)
      } else {
        reject()
      }
    })
  },
  async loadThailandPostMartCart({ state, getters, commit }, userId) {
    const response = await thailandpostmartApi.getCart(userId, {
      page_id: getters.getPageProfile.pageid
    })
    if (response.status === 200) {
      const { data } = response.data
      commit(
        'SET_ALL_CART',
        data.map((item) => ({
          quantity: parseInt(item.quantity),
          currency: 'THB',
          categoryid: 0,
          description: item.product_description,
          id: item.sku,
          name: item.product_title,
          pageid: state.pageProfile.pageid,
          photourl: item.product_thumb,
          price: item.product_price,
          productStock: {
            id: item.sku,
            type: 'Normal',
            quantity: 99
          },
          selectedOption: null,
          discountprice: item.product_sale_net,
          weight: 0
        }))
      )
    }
  },
  async addThailandPostMartCart({ state }, { product, userId }) {
    return thailandpostmartApi.addCart({
      page_id: state.pageProfile.pageid,
      social_id: userId,
      orderdetails: [{ sku: product.id, quantity: product.quantity }]
    })
  },
  async removeThailandPostMartCart({ state }, { product, userId }) {
    return thailandpostmartApi.removeCart({
      page_id: state.pageProfile.pageid,
      social_id: userId,
      orderdetails: [{ sku: product.id, quantity: product.quantity }]
    })
  }
}
